// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._16jlkb7n{flex-grow:1}\n._19pk1b66{margin-top:var(--ds-space-050,4px)}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1tket9kd{min-height:72px}\n._4cvr1y6m{align-items:flex-start}", ""]);
// Exports
module.exports = exports;
